import React from "react";
import { View, ViewProps } from "react-native";
import { cn } from "@src/packages/utils/cn";

// Single source of truth for main content max-width
export const CONTENT_MAX_WIDTH = 480; // 30rem

interface ContentContainerProps extends ViewProps {
  children: React.ReactNode;
  className?: string;
  /** Include standard horizontal padding (24px) */
  withPadding?: boolean;
}

/**
 * Shared container for main screen content.
 * Centers content and applies consistent max-width across all screens.
 */
export function ContentContainer({
  children,
  className,
  withPadding = true,
  style,
  ...props
}: ContentContainerProps) {
  return (
    <View
      className={cn("relative z-10 mx-auto w-full flex-col", className)}
      style={[
        {
          maxWidth: CONTENT_MAX_WIDTH,
          ...(withPadding && { paddingHorizontal: 24 }),
        },
        style,
      ]}
      {...props}
    >
      {children}
    </View>
  );
}
